import React, { useState, useEffect } from 'react';
import EmailList from '../components/EmailList/EmailList';
import emailService from '../services/emailService';
import './Pages.css';

function Dashboard() {
  const [emails, setEmails] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);

      // Fetch emails and stats in parallel
      const [emailsResponse, statsResponse] = await Promise.all([
        emailService.fetchEmails(),
        emailService.fetchUserStats()
      ]);

      if (emailsResponse.success) {
        setEmails(emailsResponse.emails || []);
      }

      if (statsResponse.success) {
        setStats(statsResponse.stats);
      }
    } catch (err) {
      console.error('Error fetching dashboard data:', err);
      setError('Failed to load dashboard data. Make sure the backend server is running.');
    } finally {
      setLoading(false);
    }
  };

  const handleRefresh = () => {
    fetchData();
  };

  return (
    <div className="dashboard-page">
      <div className="page-header">
        <div>
          <h1>Dashboard</h1>
          <p className="page-subtitle">Monitor your tracked emails and engagement</p>
        </div>
        <button onClick={handleRefresh} className="btn btn-secondary" disabled={loading}>
          <span>🔄</span>
          Refresh
        </button>
      </div>

      {stats && (
        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-icon">📧</div>
            <div className="stat-content">
              <div className="stat-value">{stats.totalTracked || 0}</div>
              <div className="stat-label">Total Tracked</div>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon green">✓</div>
            <div className="stat-content">
              <div className="stat-value">{stats.totalRead || 0}</div>
              <div className="stat-label">Read</div>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon gray">✓</div>
            <div className="stat-content">
              <div className="stat-value">{stats.totalUnread || 0}</div>
              <div className="stat-label">Unread</div>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon">📊</div>
            <div className="stat-content">
              <div className="stat-value">{stats.openRate || 0}%</div>
              <div className="stat-label">Open Rate</div>
            </div>
          </div>
        </div>
      )}

      <EmailList emails={emails} loading={loading} error={error} />
    </div>
  );
}

export default Dashboard;
